<template>
  <el-dialog
    :title="$t('CenterForSorting.changeCompareTitle')"
    :visible.sync="dialogVisible"
    width="760px"
    append-to-body
  >
    <el-table
      :data="compareRows"
      border
      size="small"
      :header-cell-style="{ background: '#f5f7fa', color: '#303133' }"
      max-height="520"
      class="change-compare-table"
    >
      <el-table-column prop="field" :label="$t('CenterForSorting.changeField')" min-width="220" />
      <el-table-column prop="beforeValue" :label="$t('CenterForSorting.beforeData')" min-width="240" />
      <el-table-column prop="afterValue" :label="$t('CenterForSorting.afterData')" min-width="240" />
    </el-table>
    <div v-if="compareRows.length === 0" class="empty-wrap">
      {{ $t('CenterForSorting.noChangeLogData') }}
    </div>
  </el-dialog>
</template>

<script>
import { getWaybillStatusList } from '@/utils/enumData';

export default {
  name: 'RuleChangeCompareDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    beforeData: {
      type: [String, Object, null],
      default: null
    },
    afterData: {
      type: [String, Object, null],
      default: null
    },
    conditionConfigs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      compareRows: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.buildCompareRows();
      }
    }
  },
  methods: {
    buildCompareRows() {
      const beforeObject = this.parseLogData(this.beforeData);
      const afterObject = this.parseLogData(this.afterData);
      const keySet = new Set([...Object.keys(beforeObject), ...Object.keys(afterObject)]);
      const rows = [];

      keySet.forEach(key => {
        if (key === 'SORTING_CONDITIONS_FIELD') {
          const conditionRows = this.buildConditionRows(
            beforeObject.SORTING_CONDITIONS_FIELD,
            afterObject.SORTING_CONDITIONS_FIELD
          );
          rows.push(...conditionRows);
          return;
        }
        rows.push({
          field: key,
          beforeValue: this.formatPlainValue(beforeObject[key]),
          afterValue: this.formatPlainValue(afterObject[key])
        });
      });

      this.compareRows = rows;
    },
    parseLogData(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        return {};
      }
    },
    formatPlainValue(value) {
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      if (Array.isArray(value)) {
        return value.map(item => this.formatPlainValue(item)).join(', ');
      }
      if (typeof value === 'object') {
        return JSON.stringify(value);
      }
      return String(value);
    },
    buildConditionRows(beforeList, afterList) {
      const oldList = Array.isArray(beforeList) ? beforeList : [];
      const newList = Array.isArray(afterList) ? afterList : [];
      const rowCount = Math.max(oldList.length, newList.length);
      const rows = [];

      for (let i = 0; i < rowCount; i++) {
        const oldItem = oldList[i] || {};
        const newItem = newList[i] || {};
        const conditionType = oldItem['CONDITION_TYPE'] || newItem['CONDITION_TYPE'];
        rows.push({
          field: `${this.$t('CenterForSorting.condition')}[${this.resolveCodeLabel(conditionType)}]`,
          beforeValue: this.formatConditionItem(oldItem),
          afterValue: this.formatConditionItem(newItem)
        });
      }
      return rows;
    },
    formatConditionItem(item) {
      if (!item || Object.keys(item).length === 0) return '--';

      const operatorCode = item['CONDITION_OPERATOR'] || item.operator || '';
      const conditionTypeCode = item['CONDITION_TYPE'] || item.conditionType || '';
      const conditionValue = item['CONDITION_VALUE'] || item.conditionValue || '';

      const operatorLabel = this.resolveCodeLabel(operatorCode);
      const conditionTypeLabel = this.resolveCodeLabel(conditionTypeCode);
      const conditionValueLabel = this.resolveConditionValueLabel(conditionTypeCode, conditionValue);
      return `${conditionTypeLabel} ${operatorLabel} ${conditionValueLabel}`;
    },
    resolveCodeLabel(code) {
      if (!code) return '--';
      const key = `CenterForSorting.${code}`;
      const translated = this.$t(key);
      return translated === key ? code : translated;
    },
    // 中文注释：条件值转换逻辑与 RuleConditionDetail 保持一致，确保日志对比展示与“查看条件”口径统一。
    resolveConditionValueLabel(conditionType, conditionValue) {
      if (conditionValue === null || conditionValue === undefined || conditionValue === '') {
        return '--';
      }

      if (conditionType === 'WAYBILL_STATUS') {
        const statusList = getWaybillStatusList();
        const values = String(conditionValue).split(',');
        return values.map(v => {
          const option = statusList.find(s => String(s.code) === v.trim());
          return option ? option.label : v;
        }).join(', ');
      }

      const config = this.conditionConfigs.find(item => item.conditionType === conditionType);
      if (config && config.valueType === 'Select' && config.allowedValues) {
        const values = String(conditionValue).split(',');
        return values.map(v => {
          const option = config.allowedValues.find(av => String(av.value) === v.trim());
          return option ? option.label : v;
        }).join(', ');
      }

      return String(conditionValue);
    }
  }
};
</script>

<style scoped>
.change-compare-table {
  border-radius: 8px;
}
.empty-wrap {
  padding: 12px 0 2px;
  color: #909399;
  font-size: 13px;
  text-align: center;
}
</style>
